import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from '@phosphor-icons/react';

const DealsSection = ({ deals }) => {
  const dealTypeColors = {
    FREE: 'bg-green-500',
    DISCOUNT: 'bg-gold-500',
    '2FOR1': 'bg-primary'
  };

  return (
    <section className="py-24 bg-secondary/50" data-testid="deals-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-end mb-12">
          <div>
            <span className="overline text-primary mb-4 block">Save Money</span>
            <h2 className="font-serif text-4xl text-primary">
              Wine Tasting Deals
            </h2>
          </div>
          <Link 
            to="/deals" 
            className="text-primary hover:underline flex items-center gap-1 font-medium"
            data-testid="view-all-deals-link"
          >
            View All Deals <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {deals.slice(0, 6).map((deal, index) => (
            <motion.div
              key={deal.id}
              className="bg-card rounded-lg border border-border/50 p-6 hover:shadow-soft transition-shadow"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              data-testid={`deal-card-${deal.id}`}
            >
              <div className="flex items-start justify-between mb-4">
                <span className={`${dealTypeColors[deal.deal_type] || 'bg-primary'} text-white text-xs font-bold px-3 py-1 rounded-full`}>
                  {deal.deal_type === '2FOR1' ? '2 FOR 1' : deal.deal_type}
                </span>
              </div>
              <h3 className="font-serif text-lg text-primary mb-2">{deal.winery_name}</h3>
              <p className="text-foreground font-medium mb-2">{deal.title}</p>
              <p className="text-muted-foreground text-sm">{deal.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DealsSection;
